<template>
  <button
    class="button is-white trf-scroll is-inline-block"
    :class="adquirirClass"
    :id="id"
    :title="title"
    :style="adquirirStyles"
    v-if="!showOnScroll || (showOnScroll && isScrolled)"
    @click="scrollToTop"
  >
    <span class="icon is-size-3 m-0 p-0 is-text-primary">
      <i class="mdi mdi-arrow-up-bold-circle"></i>
    </span>
    <br/>
    <span>Voltar ao topo!</span>
  </button>
</template>
<script>
export default {
  name: "TrfVoltarAoTopo",
  props: {
    id: String,
    title: String,
    position: {
      type: [String],
      required: false,
      default: "bottom-right",
    },
    zIndex: {
      type: [String],
      required: false,
      default: "11",
    },
    showOnScroll: {
      type: [Boolean],
      required: false,
      default: true
    },
  },
  data() {
    return {
      isScrolled: false
    };
  },
  methods: {
    iniciarListener() {
      if (this.showOnScroll) {
        document.addEventListener("scroll", this._isScrolled);
      }
    },
    removerListener() {
      if (this.showOnScroll) {
        document.removeEventListener("scroll", this._isScrolled);
      }
    },
    _isScrolled() {
      const page = document.querySelector('html');
      const top = page.scrollTop;
      this.isScrolled = top > 0
      return this.isScrolled;
    },
    scrollToTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  },
  mounted() {
    this.iniciarListener();
  },
  deactivated() {
    this.removerListener();
  },
  beforeUnmounted(){
    this.removerListener();
  },
  computed: {
    adquirirStyles() {
      const styles = `z-index: ${this.zIndex};`;
      return styles;
    },
    adquirirClass() {
      const classes = {};
      switch(this.position) {
        case "bottom-right":
          classes['trf-scroll-position-bottom-right'] = true;
          break;
        case "bottom-left":
          classes['trf-scroll-position-bottom-left'] = true;
          break;
        case "top-right":
          classes['trf-scroll-position-top-right'] = true;
          break;
        case "top-left":
          classes['trf-scroll-position-top-left'] = true;
          break;
        case "bottom":
          classes['trf-scroll-position-bottom'] = true;
          break;
        case "top":
          classes['trf-scroll-position-top'] = true;
          break;
        case "left":
          classes['trf-scroll-position-left'] = true;
          break;
        case "right":
          classes['trf-scroll-position-right'] = true;
          break;
      }
      return classes
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
.trf-scroll{
  position:fixed;
  background-color:transparent;
  border: 0 none;
  outline: 0 none;
  box-shadow: 0 0 0 transparent;
  height:auto;
  &:hover, &:active, *:focus {
    background-color:transparent;
  }
  &-position {
    &-bottom-right {
      bottom:7em;
      right:2em;
    }
    &-bottom-left {
      bottom:7em;
      left:2em;
    }
    &-top-right {
      top:2em;
      right:2em;
    }
    &-top-left {
      top:2em;
      left:2em;
    }
    &-bottom {
      bottom:7em;
      left:50%;
      transform:translateX(-50%);
    }
    &-top {
      top:2em;
      left:50%;
      transform:translateX(-50%);
    }
    &-left {
      left:2em;
      top:50%;
      transform:translateY(-50%);
    }
    &-right {
      right:2em;
      top:50%;
      transform:translateY(-50%);
    }
  }
}
</style>
